<template>
    <c-modal @close="close" :title="'Item updaten'">

        <c-form ref="form" @valid="submit" class="margin-t-40">

            <c-input
                type="text"
                name="serial"
                v-model="serial"
                :label="'Serienummer'"
                :horizontal="true"
            />

            <c-input
                type="text"
                name="order-number"
                v-model="order_number"
                :label="'Ordernummer'"
                :horizontal="true"
            />

            <c-input
                type="text"
                name="tag-number"
                v-model="tag_number"
                :label="'Asset ID'"
                :horizontal="true"
            />

            <c-input
                type="text"
                name="mac_address"
                v-model="mac_address"
                :label="'MAC Adres'"
                :horizontal="true"
            />

            <c-datepicker
				:label="'Aanschafdatum'"
				name="date_in_use"
				:horizontal="true"
				v-model="dateInUse"
                :disabled="disabled">
			</c-datepicker>

            <c-select
				:label="'In gebruik door'"
				:horizontal="true"
				:options="contacts"
				v-model="client_id"
				:ValueName="'client_id'"
				name="first_name,last_name"
				:required="true">
			</c-select>

            <c-zipcode-address v-if="item.address"
				:label="'Postcode en hnr.'"
				:sublabel="'Bezoekadres'"
				:horizontal="true"
				:zipcode="item.address.zipcode"
				:number="item.address.number"
				:street="item.address.street"
				:city="item.address.city"
				:addition="item.address.addition !== null ? item.address.addition : ''"
				:name="item.address.name !== null ? item.address.name : ''"
				ref="address"
			/>

            <c-zipcode-address v-else
				:label="'Postcode en hnr.'"
				:sublabel="'Adres'"
				:horizontal="true"
				name="*"
                ref="address"
			/>

            <div class="row collapse align-right">
                <div class="columns shrink">
                    <c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Item updaten</c-button>
                </div>
            </div>

        </c-form>

    </c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CDatepicker from '@components/form/input/Datepicker';
import {ValidationError} from '@app/errors';
import CZipcodeAddress from '@components/ZipcodeAddress';
import { resolveTransitionHooks } from 'vue';

export default {
    mixins: [Form],
    components: {
        CModal, CDatepicker, CZipcodeAddress
    },
    props: {
        item: {
            required: false
        }
    },
    data() {
        return {
            serial: '',
            order_number: '',
            tag_number: '',
            mac_address: '',
            dateInUse: '',
            client_id: '',
            contacts: {},
            disabled: false
        };
    },
    watch: {},
    methods: {
        submit() {

            let data = {
                status_id: this.item.status_id,
                product_id: this.item.product.id,
                serial: this.serial,
                order_number: this.order_number,
                tag_number: this.tag_number,
                mac_address: this.mac_address,
                date_in_use: this.dateInUse,
                address: this.$refs.address.getData(),
                client_id: this.client_id ?? null
            };

            data._method = 'PUT';
            this.$xhr.post('/api/items/' + this.item.id, data).then(({result}) => {
                this.close();
                this.$emit('added');
                this.disabled = this.dateInUse ? true : false;
                this.$store.dispatch('toast/success', {title: 'Item aanpassen', text: 'Het item is aangepast'});
            }).catch((e) => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.$store.dispatch('toast/alert', {
                    title: 'Item aanpassen',
                    text: 'Er is helaas iets fout gegaan bij het aanpassen van het item'
                });
            });

        },
        close() {
            this.$emit('close');
        },
    },
    mounted() {
        this.serial = this.item.serial;
        this.order_number = this.item.order_number;
        this.tag_number = this.item.tag_number;
        this.mac_address = this.item.mac_address;
        this.dateInUse = this.item.date_in_use;
        this.client_id = this.item.client_id;
        this.disabled = this.item.date_in_use ? true : false;
        this.$xhr.get('/api/getendclientsdetailbyparentid/' + this.item.product.client_id).then( ({result}) => {

                this.contacts = result;
                this.contacts.unshift({
                    client_id: null,
                    firstname: '',
                    lastname: ''
                });


			}).catch((e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klantgegevens kunnen niet worden ingeladen'});
			});
    }
}
</script>
